module.exports = __webpack_public_path__ + "static/media/noun_Settings_661334.f51a06c3.svg";